import { handleActions } from 'redux-actions';
import { httpActions } from '@figure/frontlib-onboarding-redux';
import { TRUEWORK_GET_TOKENS } from '../actions/truework-actions';

const { SUCCESS, FAILURE } = httpActions;

export const initialState = {
  token: '',
  error: '',
};

const reducer = handleActions(
  {
    [`${TRUEWORK_GET_TOKENS}_${FAILURE}`](state, action) {
      return {
        ...state,
        error: action.payload.error,
      };
    },
    [`${TRUEWORK_GET_TOKENS}_${SUCCESS}`](state, action) {
      return {
        ...state,
        token: action.payload.token,
        error: '',
      };
    },
  },
  initialState
);

export default reducer;
